<template>
  <div class="col-xs-12">
    <form enctype="multipart/form-data" @submit.prevent="addBundleForm">
      <div id="customers-panel" class="panel panel-primary">
        <div class="panel-heading" style="text-align: left">
          Create New Bundle <br />
        </div>
        <div class="panel-body">
          <div v-if="product" class="form-group">
            <label class="control-label">Bundle Label*</label>
            <input
              class="form-control"
              type="text"
              name="label"
              :value="productLabel"
              required
              @change="setProductLabel($event)"
            />
          </div>

          <div v-if="productMetaSku" class="form-group">
            <label class="control-label">Nuance Sku*</label>
            <input
              class="form-control"
              type="text"
              name="sku"
              :value="productMetaSku"
              required
            />
          </div>

          <div
            :class="
              itemNameExist ? 'has-error has-feedback form-group' : 'form-group'
            "
          >
            <label class="control-label">Bundle Slug*</label>
            <input
              v-model="name"
              class="form-control"
              type="text"
              name="name"
              value=""
              required
              @change="getItemName()"
            />
            <span
              v-if="itemNameExist"
              class="glyphicon glyphicon-remove form-control-feedback"
            ></span>
            <span v-if="itemNameExist" class="help-block">
              Please select a different Slug.
            </span>
            <span class="help-block">Unique slug of this bundle</span>
          </div>

          <div v-if="vendors" class="form-group">
            <label class="control-label">Vendor*</label>
            <select v-model="vendor" class="form-control" name="vendor">
              <option
                v-for="vendorItem in vendors"
                :key="'vendor_' + vendorItem.id"
                :value="vendorItem.id"
              >
                {{ vendorItem.name }}
              </option>
            </select>
          </div>

          <div v-if="product" class="form-group">
            <label class="control-label">Description*</label>
            <editor
              v-model="description"
              api-key="qikbpk8rdl84ppg4fbhzx8x623m4v13szu2vyqnrac209vbg"
              :initial-value="product.description"
              :init="{
                plugins: ['link image code lists'],
                height: '300px',
                toolbar:
                  'undo redo| styleselect | bold italic | link image | alignleft aligncenter alignright alignjustify alignnone | numlist bullist | code |',
              }"
            ></editor>
          </div>

          <div class="form-group">
            <label class="control-label">Short Description*</label>
            <input
              id="short_description"
              v-model="short_description"
              type="text"
              class="form-control"
              name="short_description"
              value=""
            />
            <span class="help-block">
              Short description that appears under the product in email receipts
            </span>
          </div>

          <div class="form-group">
            <label class="control-label">Bundle Content</label>
            <div id="content_list">
              <table class="table">
                <thead>
                  <tr>
                    <th>Content Type</th>
                    <th>Content Source</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(content, index) in contentAssets"
                    :key="'content_' + index"
                    style="background-color: #f9f9f9"
                  >
                    <td>
                      <select
                        name="content_type"
                        class="form-control"
                        @change="handleFileTypeChange($event, index)"
                      >
                        <option
                          :selected="content.content_source === 'image'"
                          value="image"
                        >
                          Image
                        </option>
                        <option
                          :selected="content.content_source === 'video'"
                          value="video"
                        >
                          Youtube Video
                        </option>
                      </select>
                    </td>
                    <td>
                      <input
                        v-if="content.content_source === 'image'"
                        data-default-type="file"
                        class="form-control"
                        type="file"
                        name="content_img"
                        @change="handleImageFile($event, index)"
                      />
                      <input
                        v-if="content.content_source === 'video'"
                        data-default-type="text"
                        class="form-control"
                        name="content_src"
                        placeholder="Youtube Video ID (e.g. 1i3jYOg8HOw"
                        @change="handleVideoInput($event, index)"
                      />
                    </td>
                    <td>
                      <button
                        v-if="contentAssets.length > 1 && index > 0"
                        type="button"
                        class="close"
                        data-toggle="tooltip"
                        title="Remove"
                        @click="handleDeleteContentItem(index)"
                      >
                        <span
                          aria-hidden="true"
                          class="glyphicon glyphicon-remove"
                        ></span>
                      </button>
                    </td>
                    <td colspan="3">
                      <button
                        id="add_more_content"
                        type="button"
                        class="close"
                        style="width: 100%"
                        @click="handleAddMoreContent"
                      >
                        <span class="glyphicon glyphicon-plus"></span>&nbsp;Add
                        More
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="productDetailsTemplate" class="form-group">
            <label class="control-label">Bundle Display Body*</label>
            <editor
              v-model.lazy="display_body"
              api-key="qikbpk8rdl84ppg4fbhzx8x623m4v13szu2vyqnrac209vbg"
              :initial-value="productDetailsTemplate"
              :init="{
                plugins: ['link image code lists'],
                height: '400px',
                content_css: ['/css/app.css'],
                selector: 'div#collapse1',
                content_style: '.collapse {display: block !important}',
                toolbar:
                  'undo redo| styleselect | bold italic | link image | alignleft aligncenter alignright alignjustify alignnone | numlist bullist | code |',
              }"
            ></editor>
          </div>

          <div v-if="productMetaTerms" class="form-group">
            <label class="control-label">Product Terms*</label>
            <editor
              v-model.lazy="product_terms"
              :api-key="tiny_key"
              :initial-value="productMetaTerms"
              :init="{
                plugins: ['link image code lists'],
                height: '400px',
                content_css: '/css/app.css',
                toolbar:
                  'undo redo| styleselect | bold italic | link image | alignleft aligncenter alignright alignjustify alignnone | numlist bullist | code |',
              }"
            ></editor>
          </div>
          <hr />
          <div class="row">
            <div class="form-group col-xs-12">
              <label class="control-label">Sort Order*</label>
              <input
                v-model="sort_order"
                class="form-control"
                type="number"
                name="sort_order"
                min="0"
                step="1"
                value=""
                required
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label">Key Words*</label>
          <input
            v-model="key_words"
            class="form-control"
            type="text"
            name="key_words"
            value=""
            required
          />
        </div>

        <div class="form-group">
          <label class="control-label">Product Disclaimer</label>
          <input
            v-model="disclaimer"
            class="form-control"
            type="text"
            name="disclaimer"
            value=""
          />
        </div>

        <div class="form-group">
          <label class="control-label">Cycle Price Disclaimer</label>
          <input
            v-model="cycle_price_disclaimer"
            class="form-control"
            type="text"
            name="cycle_price_disclaimer"
            value=""
          />
          <span class="help-block">
            Text that appears as a tooltip when hovering over the discounted
            price on the product page. Optional, but recommended if the bundle
            is for a discounted subscription.
          </span>
        </div>

        <hr />

        <div class="form-group">
          <div class="checkbox">
            <label>
              <input
                type="checkbox"
                name="has_discount"
                :value="hasDiscountCheckBox"
                @change="handleCheckBoxClick($event, 'has_discount')"
              />
              Has Discount
            </label>
          </div>
          <div
            id="discount_opts"
            class="well"
            :class="hasDiscountCheckBox && discounts ? '' : 'hidden'"
          >
            <div class="form-group col-xs-12">
              <select
                class="form-control"
                name="product_discount"
                @change="handleDiscountSelect"
              >
                <option :selected="productDiscount === null" value="">
                  -- Select Discount --
                </option>
                <option
                  v-for="(discount, i) in discounts"
                  :key="'discount_' + i"
                  :data-duration="discount.duration"
                  :data-amount="discount.amount"
                  :value="discount.id"
                >
                  {{ discount.code }}
                </option>
              </select>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox">
            <label>
              <input
                type="checkbox"
                name="has_addon"
                :value="hasAddonCheckBox"
                @change="handleCheckBoxClick($event, 'has_addon')"
              />
              Has Addon
            </label>
          </div>
          <div
            id="addon_select"
            class="well"
            :class="hasAddonCheckBox && addons ? '' : 'hidden'"
          >
            <div class="row">
              <div class="form-group col-xs-12">
                <select
                  class="form-control"
                  name="product_addons"
                  @change="handleProductAddonSelect"
                >
                  <option :selected="productAddon == null" value="">
                    -- Select Addon --
                  </option>
                  <option
                    v-for="(addon, i) in addons"
                    :key="'addon_' + i"
                    :value="addon.id"
                  >
                    {{ addon.code }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox">
            <label>
              <input
                type="checkbox"
                name="has_renewal"
                :value="hasRenewalCheckBox"
                @change="handleCheckBoxClick($event, 'has_renewal')"
              />
              Has Renewal
            </label>
          </div>
          <div
            id="renewal_select"
            class="well"
            :class="hasRenewalCheckBox && renewals ? '' : 'hidden'"
          >
            <div class="row">
              <div class="form-group col-xs-12">
                <select
                  class="form-control"
                  name="product_renewals"
                  @change="handleRenewalSelect"
                >
                  <option :selected="productRenewal == null" value="">
                    -- Select Renewal --
                  </option>
                  <option
                    v-for="(renewal, i) in renewals"
                    :key="'renewal_' + i"
                    :value="renewal.id"
                  >
                    {{ renewal.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox">
            <label>
              <input
                type="checkbox"
                name="is_gated"
                :value="isGatedCheckBox"
                @change="handleCheckBoxClick($event, 'is_gated')"
              />
              Is Gated
            </label>
          </div>
          <div
            id="gated_opts"
            class="well"
            :class="isGatedCheckBox && gates ? '' : 'hidden'"
          >
            <div class="row">
              <div class="form-group col-xs-12">
                <select
                  id="gated_id"
                  class="form-control"
                  name="gated_id"
                  @change="handleGateSelect"
                >
                  <option value="0">Add New...</option>
                  <option
                    v-for="(gate, i) in gates"
                    :key="'gate_' + i"
                    :value="gate.id"
                  >
                    {{ gate.code }}
                  </option>
                </select>
              </div>

              <div id="gated_select">
                <div class="form-group col-xs-6">
                  <input
                    class="form-control"
                    type="text"
                    name="gated_code"
                    placeholder="Gated code..."
                    value=""
                    @change="handleGateCode"
                  />
                </div>
                <div class="form-group col-xs-6">
                  <input
                    class="form-control"
                    type="text"
                    name="gated_msg"
                    placeholder="Gated message..."
                    value=""
                    @change="handleGateMsg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox">
            <label>
              <input
                :value="isDisabled"
                type="checkbox"
                name="is_disabled"
                @change="handleCheckBoxClick($event, 'is_disabled')"
              />
              Disabled
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox">
            <label>
              <input
                :value="isUpgrade"
                type="checkbox"
                name="is_upgrade"
                @change="handleCheckBoxClick($event, 'is_upgrade')"
              />
              Is Upgrade
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox">
            <label>
              <input
                :value="isSegment"
                type="checkbox"
                name="is_segment"
                @change="handleCheckBoxClick($event, 'is_segment')"
              />
              Is Segment
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox">
            <label>
              <input
                :value="isStandalone"
                type="checkbox"
                name="is_standalone"
                @change="handleCheckBoxClick($event, 'is_standalone')"
              />
              Is Standalone
            </label>
          </div>
        </div>

        <div id="template_description" class="hidden"></div>
        <div id="template" class="hidden"></div>
        <div id="template_terms" class="hidden"></div>
        <hr />
        <span style="display: inline-block">
          <h5>Cycle Costs Preview</h5>
        </span>
        <div v-if="cycles && loadingCycles === false">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="cycles"></div>
        </div>
        <div v-else-if="loadingCycles">
          <div class="text-center">
            <img src="/build/img/loading.gif" width="75" height="75" />
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <button type="submit" class="btn btn-primary" :disabled="loadingSubmit">
          <span v-if="loadingSubmit === false">Submit</span>
          <span v-else-if="loadingSubmit === true">Processing...</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";

export default {
  components: {
    Editor,
  },
  data() {
    return {
      name: null,
      sku: null,
      vendor: null,
      key_words: null,
      disclaimer: null,
      sort_order: null,
      cycle_price_disclaimer: null,
      description: null,
      short_description: null,
      display_body: null,
      product_terms: null,
      tiny_key: process.env.MIX_TINY_KEY,
    };
  },
  computed: {
    productId() {
      return this.$store.state.bundle.product_id;
    },
    product() {
      return this.$store.state.bundle.product;
    },
    productMeta() {
      return this.$store.state.bundle.product_meta;
    },
    productMetaSku() {
      return this.$store.getters.product_meta_sku;
    },
    productMetaDuration() {
      return this.$store.getters.product_meta_duration;
    },
    productMetaTerms() {
      return this.$store.getters.product_meta_terms;
    },
    vendors() {
      return this.$store.state.bundle.vendors;
    },
    hasDiscountCheckBox() {
      return this.$store.state.bundle.has_discount_check_box;
    },
    hasAddonCheckBox() {
      return this.$store.state.bundle.has_addon;
    },
    hasRenewalCheckBox() {
      return this.$store.state.bundle.has_renewal;
    },
    isGatedCheckBox() {
      return this.$store.state.bundle.is_gated;
    },
    contentAssets() {
      return this.$store.state.bundle.content_assets;
    },
    discounts() {
      return this.$store.state.bundle.discounts;
    },
    addons() {
      return this.$store.state.bundle.addons;
    },
    renewals() {
      return this.$store.state.bundle.renewals;
    },
    gates() {
      return this.$store.state.bundle.gates;
    },
    cycles() {
      return this.$store.state.bundle.cycles;
    },
    itemNameExist() {
      return this.$store.state.bundle.item_name;
    },
    productAddon() {
      return this.$store.state.bundle.product_addon;
    },
    productDiscount() {
      return this.$store.state.bundle.product_discount;
    },
    productRenewal() {
      return this.$store.state.bundle.product_renewal;
    },
    getCyclesData() {
      return {
        product_id: this.productId,
        has_addon: this.hasAddonCheckBox,
        product_addons: this.productAddon,
        has_discount: this.hasDiscountCheckBox,
        product_discount: this.productDiscount,
      };
    },
    loadingCycles() {
      return this.$store.state.bundle.loading_cycles;
    },
    gateId() {
      return this.$store.state.bundle.gated_id;
    },
    gateCode() {
      return this.$store.state.bundle.gated_code;
    },
    gateMsg() {
      return this.$store.state.bundle.gated_msg;
    },
    isDisabled() {
      return this.$store.state.bundle.is_disabled;
    },
    isUpgrade() {
      return this.$store.state.bundle.is_upgrade;
    },
    isSegment() {
      return this.$store.state.bundle.is_segment;
    },
    isStandalone() {
      return this.$store.state.bundle.is_standalone;
    },
    contentType() {
      return this.$store.getters.get_content_type;
    },
    contentImg() {
      return this.$store.getters.get_content_image;
    },
    contentSrc() {
      return this.$store.getters.get_content_src;
    },
    loadingSubmit() {
      return this.$store.state.bundle.loading_submit;
    },
    productDetailsTemplate() {
      return this.$store.state.bundle.product_details_template;
    },
    isGated() {
      return this.$store.state.bundle.is_gated;
    },
    productLabel() {
      return this.$store.state.bundle.product_label;
    },
  },
  created() {
    this.$store
      .dispatch("setProductId", window.location.pathname)
      .then((productId) => {
        this.$store.dispatch("getProductMeta", productId);
        this.$store.dispatch("getProductInfo", productId).then((localeId) => {
          this.$store.dispatch("getGates", localeId);
          this.$store.dispatch("getAddons", localeId);
          this.$store.dispatch("getVendors", localeId);
          this.$store.dispatch("getRenewals", localeId);
          this.$store.dispatch("getDiscounts", localeId);
          this.$store.dispatch("getCycles", this.getCyclesData);
          this.display_body = this.$store.state.bundle.product_details_template;
          this.product_terms = this.productMetaTerms;
        });
      });
  },
  mounted() {
    this.$store.dispatch("setInitialBundleAssets");
    this.$store.dispatch("setProductDetailsTemplate");
  },
  methods: {
    addBundleForm() {
      this.validateName();
      const formFields = this.getFormFields();
      this.$store.dispatch("submitAddNewBundleForm", formFields);
    },
    getFormFields() {
      return {
        label: this.product.label,
        sku: this.productMetaSku,
        name: this.name,
        vendor: this.vendor,
        description: this.description,
        short_description: this.short_description,
        display_body: this.display_body,
        product_terms: this.product_terms,
        sort_order: this.sort_order,
        key_words: this.key_words,
        disclaimer: this.disclaimer,
        cycle_price_disclaimer: this.cycle_price_disclaimer,
        has_discount: this.hasDiscountCheckBox,
        product_discount: this.productDiscount,
        has_addon: this.hasAddonCheckBox,
        product_addons: this.productAddon,
        product_renewals: this.productRenewal,
        gated_id: this.gateId,
        gated_code: this.gateCode,
        gated_msg: this.gateMsg,
        content_type: this.contentType,
        content_src: this.contentSrc,
        content_img: this.contentImg,
        is_gated: this.isGated,
        is_disabled: this.isDisabled,
        is_upgrade: this.isUpgrade,
        is_segment: this.isSegment,
        is_standalone: this.isStandalone,
      };
    },
    handleCheckBoxClick(event, type) {
      const checkBoxStatus = event.target.value;
      const data = { status: checkBoxStatus, type };
      this.$store.dispatch("setCheckBoxStatus", data);
      if (type === "has_discount" || type === "has_addon") {
        this.$store.dispatch("getCycles", this.getCyclesData);
      }
    },
    // eslint-disable-next-line consistent-return
    validateName() {
      if (!this.itemNameExist) {
        return true;
      }
      this.$store.dispatch("triggerNameAlert");
    },
    handleFileTypeChange(event, index) {
      const type = event.target.value;
      const data = { type, index };
      this.$store.dispatch("setContentSourceInput", data);
    },
    handleImageFile(e, index) {
      const image = e.target.files[0];

      this.$store.dispatch("setBundleImage", { content_image: image, index });
    },
    handleVideoInput(event, index) {
      this.$store.dispatch("setVideoInput", {
        index,
        value: event.target.value,
      });
    },
    handleAddMoreContent() {
      this.$store.dispatch("addBundleAsset");
    },
    getItemName(event) {
      const itemName = event.target.value;
      this.$store.dispatch("getItemName", itemName);
    },
    handleProductAddonSelect(event) {
      const addonId = event.target.value;
      this.$store.dispatch("setProductAddon", addonId);
      this.$store.dispatch("getCycles", this.getCyclesData);
    },
    handleDiscountSelect(event) {
      const discountId = event.target.value;
      this.$store.dispatch("setDiscount", discountId);
      this.$store.dispatch("getCycles", this.getCyclesData);
    },
    handleRenewalSelect(event) {
      const id = event.target.value;
      this.$store.dispatch("setRenewal", id);
    },
    handleGateSelect(event) {
      const id = event.target.value;
      this.$store.dispatch("seGateSelect", id);
    },
    handleGateCode(event) {
      const val = event.target.value;
      this.$store.dispatch("seGateCode", val);
    },
    handleGateMsg(event) {
      const val = event.target.value;
      this.$store.dispatch("seGateMsg", val);
    },
    handleDeleteContentItem(index) {
      this.$store.dispatch("handleDeleteContentItem", index);
    },
    setProductLabel(event) {
      this.$store.dispatch("setProductLabel", event.target.value);
    },
  },
};
</script>
